/**
 * `[[wikilink]]` plumbing that carries no markdown dependency, so the Page view
 * can lazy-load the (heavier) renderer while wiring click handling eagerly.
 */

/** The slug from a `kip:` href, or null for a real/external link. */
export function wikilinkSlug(href: string | null | undefined): string | null {
  if (!href || !href.startsWith('kip:')) return null;
  return href.slice(4) || null;
}

/**
 * Svelte action: delegate clicks on `kip:` links inside a rendered body to
 * `onWikilink(slug)`. External links fall through untouched.
 */
export function wikilinks(node: HTMLElement, onWikilink: (slug: string) => void) {
  let handler = onWikilink;
  const onClick = (e: MouseEvent) => {
    const a = (e.target as HTMLElement).closest('a');
    if (!a) return;
    const slug = wikilinkSlug(a.getAttribute('href'));
    if (slug === null) return;
    e.preventDefault();
    handler(slug);
  };
  node.addEventListener('click', onClick);
  return {
    update: (next: (slug: string) => void) => {
      handler = next;
    },
    destroy: () => node.removeEventListener('click', onClick),
  };
}
